/**
 * A simple service to manage a unique session identifier for tracking.
 */

const SESSION_KEY = 'pathfinder_session_id';

// Function to generate a simple, random unique ID.
const generateUniqueId = () => {
  return Date.now().toString(36) + Math.random().toString(36).substring(2);
};

/**
 * Retrieves the current session ID from sessionStorage.
 * If one doesn't exist for the current session, it creates and stores a new one.
 * @returns {string} The unique session identifier.
 */
const getSessionId = () => {
  let sessionId = sessionStorage.getItem(SESSION_KEY);

  if (!sessionId) {
    sessionId = generateUniqueId();
    sessionStorage.setItem(SESSION_KEY, sessionId);
  }

  return sessionId;
};

const SessionService = {
  getSessionId
};

export default SessionService;
